import React from 'react';

const BagIcon = ({ size = 18, ...props }) => (
  <svg
    width={Math.round((size * 18) / 16)}
    height={size}
    viewBox='0 0 18 16'
    fill='currentColor'
    {...props}>
    <path
      d='M 13.859 14.035 L 13.428 16 L 1.548 16 L 1.98 14.035 L 13.859 14.035 Z M 18 4.206 L 15.84 14.035 L 13.859 14.035 L 15.587 6.171 L 13.608 6.171 L 13.176 8.138 L 11.197 8.138 L 11.628 6.171 L 7.668 6.171 L 7.236 8.138 L 5.257 8.138 L 5.688 6.171 L 3.708 6.171 L 1.98 14.035 L 0 14.035 L 2.16 4.206 L 6.117 4.206 L 6.233 3.703 C 6.689 1.63 8.696 0 10.804 0 C 11.885 0 12.828 0.426 13.456 1.201 C 14.09 1.982 14.318 3.048 14.081 4.126 L 14.063 4.206 L 18 4.206 Z M 11.933 2.419 C 11.683 2.111 11.282 1.942 10.804 1.942 C 9.621 1.942 8.401 2.941 8.142 4.126 L 8.123 4.206 L 12.057 4.206 L 12.173 3.703 C 12.282 3.204 12.198 2.745 11.933 2.419 Z'
      fillRule='nonzero'
    />
  </svg>
);

export default BagIcon;
